import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import styled from 'styled-components'

export const ZapierActions = () => {
  const {t} = useI18n()
  return (
    <Wrapper>
      <ActionCard>
        <Title>
          <PersonAddIcon /> {t('orgZapier.actionCreateTitle')}
        </Title>

        <Description>{t('orgZapier.actionCreateDesc')}</Description>

        <FieldsTitle>{t('orgZapier.requiredFields')}</FieldsTitle>

        <FieldsList>
          <li>
            <strong>Email</strong> (string)
            <small>{t('orgZapier.fieldEmailHint')}</small>
          </li>
          <li>
            <strong>Reservation</strong> (boolean)
            <small>{t('orgZapier.fieldReservationHint')}</small>
          </li>
        </FieldsList>
      </ActionCard>

      <ActionCard>
        <Title>
          <PersonRemoveIcon /> {t('orgZapier.actionRemoveTitle')}
        </Title>

        <Description>{t('orgZapier.actionRemoveDesc')}</Description>

        <FieldsTitle>{t('orgZapier.requiredFields')}</FieldsTitle>

        <FieldsList>
          <li>
            <strong>Email</strong> (string)
            <small>{t('orgZapier.fieldEmailHint')}</small>
          </li>
        </FieldsList>
      </ActionCard>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

const ActionCard = styled.div`
  background: #ebebeb;
  border-radius: 5px;
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Title = styled.h5`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 16px;
  margin: 0;
`

const Description = styled.p`
  margin: 0;
  color: var(--clr-text-secondary);
  font-size: 14px;
  line-height: 1.5;
`

const FieldsTitle = styled.h6`
  margin: 0;
  padding-top: 6px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  opacity: 0.85;
`

const FieldsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding-left: 18px; /* bullet alignment */

  li {
    list-style: disc;
    font-size: 14px;
    line-height: 1.45;
  }

  strong {
    font-weight: 600;
  }

  small {
    display: block;
    font-size: 13px;
    color: var(--clr-text-secondary);
    margin-top: 3px;
  }
`
